export function dateToId(date = new Date()): string {
  return new Intl.DateTimeFormat('pl-PL', {
    dateStyle: 'short',
    timeStyle: 'medium',
    timeZone: 'Poland',
  }).format(date).replace(/\D+/g, '-');
}
